import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.css"; // TODO: import this in application.css?

export default class extends Controller {
  connect() {
    const initialValue = JSON.parse(this.element.dataset.initial);
    const autofocus = this.element.dataset.autofocus === "true";
    this.control = new TomSelect(this.element, {
      create: false,
      options: [initialValue],
      items: [initialValue.code],
      load: (query, callback) => {
        this.fetchLocations(query, callback);
      },
      maxItems: 1,
      valueField: "code",
      labelField: "name",
      searchField: ["code", "name"],
      loadThrottle: 200,
      optionClass: "ts-option",
      loadingClass: "ts-loading", // default `loading` conflicts with DaisyUI
      itemClass: "ts-item",
      render: {
        loading: function (_data, _esc) {
          return '<div class="ts-spinner-wrapper"><div class="loading loading-ring loading-sm text-primary"></div></div>';
        },
        item: (item, esc) => {
          if (item.type === "city") {
            return `<div>${esc(item.name)}, ${esc(item.country.name)} (${esc(
              item.code
            )})</div>`;
          } else {
            return `<div>${esc(item.name)} (${esc(item.code)})</div>`;
          }
        },
        option: (item, esc) => {
          if (item.type === "city") {
            return `<div>${esc(item.name)}, ${esc(item.country.name)} (${esc(
              item.code
            )})</div>`;
          } else {
            return `<div>${esc(item.name)} (${esc(item.code)})</div>`;
          }
        },
        no_results: function (data, esc) {
          return '<div class="no-results">Nothing found</div>';
        },
      },
      onInitialize() {
        this.originalValue = this.getValue(); // Save initial value
      },
      onFocus() {
        this.clear(true); // Clear selected item but don't trigger change
      },
      onBlur() {
        if (!this.getValue() && !this.input.value.trim()) {
          this.setValue(this.originalValue); // Restore if nothing typed
        }
      },
      onItemAdd(value, item) {
        this.blur();
      },
    });
    if (autofocus) {
      this.control.focus();
    }
    // TODO: add the option to move focus to submit button after selection
  }

  disconnect() {
    this.control?.destroy();
  }

  async fetchLocations(term, callback) {
    // const delay = new Promise((resolve) => setTimeout(resolve, 100000));
    // await delay;

    // NOTE: the way Kiwi works with parameter arrays...
    const locationTypes = ["city", "airport"].reduce((acc, type) => {
      return `${acc}&location_types=${type}`;
    }, "");

    const query =
      new URLSearchParams({
        term: term ?? "",
        locale: "en-US", // TODO: set locale
        limit: "10",
        active_only: "true",
      }).toString() + locationTypes;
    const path = `/locations/query?${query}`;

    fetch(path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        callback(
          json.locations.map((location) => this.#sanitizeLocation(location))
        );
      })
      .catch((error) => {
        console.error("Error fetching locations:", error);
        callback();
      });
  }

  #sanitizeLocation(location) {
    return {
      id: location.id,
      code: location.code,
      name: location.name,
      type: location.type,
      country: {
        code: location.country?.code || location.city?.country?.code,
        name: location.country?.name || location.city?.country?.name,
      },
      city: {
        code: location.city?.code,
        name: location.city?.name,
      },
    };
  }
}
